"use client";

import { Clock } from "lucide-react";

export function EarlyAccessBadge({ hours, releaseDate }: { hours: number; releaseDate: string }) {
  if (!hours || hours <= 0) return null;
  const release = new Date(releaseDate);
  const effective = new Date(release.getTime() - hours * 60 * 60 * 1000);
  const now = Date.now();
  const opensEarly = effective.getTime() <= now && release.getTime() > now;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-bold tracking-widest uppercase ${
        opensEarly ? "bg-green-500/10 text-green-600" : "bg-amber-500/10 text-amber-600"
      }`}
    >
      <Clock className="h-3 w-3" />
      {opensEarly ? `Early access live · ${hours}h early` : `Early access · ${hours}h head start`}
    </span>
  );
}
